//auth
export const LOGIN = "/api/auth/login";
export const REGISTER = "/api/auth/register";
export const REFRESH_TOKEN = "/api/auth/refresh-token";
export const FORGOT_PASSWORD = "/api/auth/forgot-password";
export const OTP_VERIFICATION = "/api/auth/otp-verify";
export const CONFIRM_PASSWORD = "/api/auth/reset-password";
export const INVITATION = "/api/auth/invitation";
export const CONFIRM_INVITATION = "/api/auth/confirm-invitation";
export const SET_PASSWORD = "/api/auth/join";
export const GOOGLE_LOGIN = "/api/auth/verify-google";

//Projects
export const PROJECT_LIST = "/api/projects";
export const CREATE_PROJECT = "/api/projects";
export const PROJECT_KEY = "/api/projects/key";
export const PROJECT_NAME = "/api/projects/validate";
export const DUE_DATE = "/api/projects/due-date";
export const DUE_DATE_DETAILS = "api/projects/due-date/details";
export const SEND_OTP = "/api/auth/send-otp";
export const STARRED_PROJECTS = "/api/projects/star";
export const GET_ALL_LABELS = "/api/labels"
export const PROJECT_COMPONENTS = "/api/components";
export const PROJECT_USERS = "/api/user-projects/projects";


//Users
export const USERS = "/api/users";

//Assign Members
export const ASSIGN_PROJECT_MEMBERS = "/api/user-projects/assign";
export const REMOVE_PROJECT_MEMBERS = "/api/user-projects/remove-user";
export const UPDATE_PROJECT_MEMBER_ROLE = "/api/user-projects";
export const USER_PROJECTS = "/api/user-projects";
export const ALL_MEMBERS = "/api/projects/members";

//Issues
export const CREATE_ISSUES = "/api/issues";
export const ISSUE_DATA = "/api/issues";
export const EDIT_ISSUE = "/api/issues";
export const DELETE_ISSUE = "/api/issues";
export const LINKED = "/api/issues/linked";
export const EXPORT_ISSUE = "/api/issues";
export const FLAG_ISSUE = "/api/issues";
export const GET_PROJECT_EPICS = "/api/issues/epic";
export const GET_ALL_STAGE_ISSUES = "/api/issues/sprint-started";

//Active sprints
export const ACTIVE_SPRINT_STAGES = "/api/stages";
export const GET_ALL_ACTIVE_SPRINT_STAGES = "/api/stages/project";
export const DRAG_ISSUES_STAGES = "/api/issues/stages";
export const ISSUES_SEQUENCE = "/api/issues/sequence";
export const PROJECT_FILTER_DETAILS = "/api/issues/filter-details";
export const UPDATE_STAGE ="/api/issues/status-update"
export const UPDATE_STAGE_STATUS = "/api/stages";


//profile
export const UPLOAD_PROFILE = "/api/users/upload-profile";
export const USER_PROFILE = "/api/users";

//Sprints
export const SPRINT_LIST = "/api/sprints/project";
export const CREATE_SPRINT = "/api/sprints";
export const SPRINT_DATA = "/api/sprints";
export const DELETE_SPRINT_DATA = "/api/sprints";
export const EDIT_SPRINT_DATA = "/api/sprints";
export const SPRINT_BACKLOG = "/api/issues/product-backlog";

//Worklog
export const ADD_WORKLOGS = "/api/issue-time-log/"
// export const GET_WORKLOGS = "/api/comments/issue";
export const EDIT_WORKLOGS = "/api/comments";

//Comments
export const ADD_COMMENTS = "/api/comments";
export const GET_COMMENTS = "/api/comments/issue";
export const EDIT_COMMENTS = "/api/comments";

//History
export const GET_HISTORY = "/api/issueHistory";

//all
export const GET_ALL = "/api/issues";

//roles
export const ROLES = "/api/roles";
export const PROJECT_ROLES = "/api/roles/project-scope";
export const APPLICATION_ROLES = "/api/roles/application-scope";
export const USER_LIST = "/api/users/all";

//icons
export const DEFAULT_ICONS = "/api/projects/default-icons";

//teams
export const GET_TEAMS = "/api/teams";
export const CREATE_TEAMS = "/api/teams";

//share issues
export const SHARE_ISSUES = "api/issues/share";

// view all issues
export const VIEW_ALL_ISSUES = "api/issues/filter";
export const GET_FILTER_PROJECTS = "api/projects/users";
export const VIEW_ALL_STASTUS = "api/stages";
export const GET_FILTER_ASSIGNEE = "api/users/project";
export const GET_FILTER_SPRINT = "api/sprints";
export const GET_ASSIGNEE_OR_REPORTERS = " updated the endpoint";

export const CREATE_PROJECTS = "/projects/create-projects";

//Release
export const RELEASES = "/api/release";
export const CREATE_RELEASE = "/api/release";
export const ADD_ISSUES_TO_RELEASE = "/api/release/issues";

// ErrorLog
export const ERRORLOG = "/api/error-logs";

// support Customer
// export const GET_SUPPORT_CUSTOMERS = "/api/projects/{projectId}/customers"
export const CUSTOMER = "/api/customer";
export const INVITE_CUSTOMER = "/api/customer/invite";
export const SET_CUSTOMER_PASSWORD = "/api/customer/join";
export const CUSTOMER_COMMENT = "/api/customer/request/comment";
export const TEST_CASES = "api/test-cases";
/** POST multipart FormData { file, projectId? } — bulk import test cases */
export const IMPORT_TEST_CASES = "api/test-cases/bulk-upload";
/** GET bulk-upload import history */
export const IMPORT_TEST_CASES_LOGS = "api/test-cases/bulk-upload/logs";
/** GET export a single bulk-upload log by id */
export const IMPORT_TEST_CASES_EXPORT_LOG = (logId) =>
  `api/test-cases/bulk-upload/export-log/${logId}`;
export const TEST_CASE_RUNS = "api/test-cases/runs";
/** GET /api/test-cases/{run-id}/summary — graph counts for a run */
export const TEST_CASE_RUN_SUMMARY = (runId) =>
  `${TEST_CASES}/${runId}/summary`;
/** GET /api/test-cases/{testCaseId}/test-run/{testRunId}/test-case-status-history */
export const TEST_CASE_STATUS_HISTORY = (testCaseId, testRunId) =>
  `${TEST_CASES}/${testCaseId}/test-run/${testRunId}/test-case-status-history`;
export const TEST_CASE_RUN_STATUS_HISTORY = (testRunId) =>
  `${TEST_CASES}/test-run/${testRunId}/test-case-status-history`;
/** GET /api/test-cases/test-run/{testRunId}/dashboard/activity-summary?days=N */
export const TEST_CASE_RUN_ACTIVITY_SUMMARY = (testRunId) =>
  `${TEST_CASES}/test-run/${testRunId}/dashboard/activity-summary`;
export const SECTIONS = "api/sections";

// DSR
export const SEND_DSR = "/api/report/dsr/send";
export const GET_DSR = "/api/report/dsr";
export const SAVE_DSR = "/api/report/dsr";

export const TIMESHEET_ENTRIES = (entryId) =>
  `/api/timesheets${entryId != null ? `/${entryId}` : ""}`;
export const TIMESHEET_SETTINGS = "/api/timesheets/settings";

//AI assistant
export const ASSISTANT_CHAT = "/api/assistant/chat";
export const ASSISTANT_ACTIONS = "/api/assistant/actions";
export const ASSISTANT_USAGE_ME = "/api/assistant/usage/me";
export const ASSISTANT_USAGE_SUMMARY = "/api/assistant/usage/summary";
export const ASSISTANT_PAGE = "/api/assistant/page";
